<template>
    <v-layout row wrap class="mb-15"> 
        <v-flex xs12 sm4 class="text-xs-center mt-5">
            <v-avatar size="150" tile>
                <img ref="avatar" 
                    :src="avatarPath" 
                    alt="Profile" 
                    :class="is_myprofle ? 'avatar-image clickable rounded-4':'avatar-image rounded-4'" 
                    @click="changeAvatar" 
                    :title="is_myprofle ? 'Click to change avatar':''">
            </v-avatar>
            <div class="subheading font-weight-medium mt-10 mb-10">
                {{basic_info.prefix}} {{basic_info.firstName}} {{basic_info.lastName}}
            </div>
        </v-flex>

        <!-- Profile Details -->
        <v-flex xs12 sm8 class="section-layout">
            <v-layout row wrap>
                <v-chip v-if="!isActiveAccount&&isMobile" outline label>
                    <v-icon color="grey">person_off</v-icon>
                    <b class="grey--text ml-10">Deactivated on {{basic_info.deactivatedOn | moment('MMM DD, YYYY')}}</b>
                </v-chip>
                <v-flex xs12>
                    <div class="caption grey--text">Employee Id</div>
                    <div>{{basic_info.employeeId}}</div>
                </v-flex>
                <v-flex xs12>
                    <div class="caption grey--text">SweldoNow Account Email</div>
                    <div>{{basic_info.email || '—'}}</div>
                </v-flex>
                <v-flex xs12>
                    <div class="caption grey--text">Mobile Number</div>
                    <div>{{cellPhone || '—'}}</div>
                </v-flex>
                <v-flex xs12 class="mb-10">
                    <div class="caption grey--text">Address</div>
                    <div>
                        {{ formattedAddress }}
                    </div>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>

import commonfn from '@/common/functions' //for refactor
import awsS3Helper from '@/helpers/aws-s3'

export default {
    components: {},
    data() {
        return {
            commonfn,
        }
    },
    props: ['is_myprofle','basic_info', 'address_info'],
    methods: {
        changeAvatar() {
            if (this.is_myprofle)
                this.$emit('changeAvatar', null)
        },
        refreshAvatar() {
            this.$refs.avatar.src = this.$store.state.avatar ?  
                                    this.$store.state.avatar : 
                                    awsS3Helper.getProfileAvatarUrl(this.$store.state.userId)
        },
    },
    computed: {
        cellPhone() {
            if (this.basic_info.phone)
                return `+63-${this.basic_info.phone.substring(2,5)}-${this.basic_info.phone.substring(5,12)}`
        },
        avatarPath() {
            if (this.is_myprofle) {
                return this.$store.state.avatar ?  
                        this.$store.state.avatar : 
                        awsS3Helper.getProfileAvatarUrl(this.$store.state.userId)
            }else{
                return awsS3Helper.getProfileAvatarUrl(this.basic_info.userId)
            }
        },
        formattedAddress() {
            if (!this.address_info) return '—';

            // 1. Pick the fields you want to join
            const parts = [
                this.address_info.addressLine1,
                this.address_info.city,
                this.address_info.province
            ];

            // 2. Filter out empty/null values and join with a comma
            const mainAddress = parts.filter(val => !!val).join(', ');

            // 3. Append Zip Code at the end without a comma (standard format)
            const zip = this.address_info.zipCode || '';

            return mainAddress ? `${mainAddress} ${zip}`.trim() : '—';
        },
        isActiveAccount() {
            return !this.basic_info.deactivated
        },
    },
}
</script>
<style scoped>
.section-layout {
    padding-left: 10px;
}
.avatar-image { 
    width: 100%; 
    height: 100%;
    object-fit: cover; /* Keeps aspect ratio by cropping sides */
}
</style>